'use client'

import { useLayoutEffect } from 'react'

import { Language, TLanguage } from '../../model/language'

type Props = {
  id: string
  language?: TLanguage
  onReady: () => void
}

let loadedLanguage: TLanguage | null = null

export const NaverMap = ({ id, language = Language.KO, onReady }: Props) => {
  useLayoutEffect(() => {
    if (loadedLanguage !== null && loadedLanguage !== language) {
      delete (window as Record<string, unknown>).naver
    }

    loadedLanguage = language

    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.src = `https://oapi.map.naver.com/openapi/v3/maps.js?ncpKeyId=${process.env.NEXT_PUBLIC_NCP_CLIENT_ID}&language=${language}`
    script.onload = onReady
    document.head.appendChild(script)

    return () => {
      script.remove()
    }
  }, [language])

  return <div id={id} style={{ width: '100%', height: '100%' }} />
}
